import React from 'react';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import './Styles/Jobs.scss';
import image from '../../../Assets/Cards/aboutcurrent.webp';
const Jobs=()=>{
    return(
        <div className="jobs-about">
            <h1>A great adventure awaits...</h1>
            <p>Join one of the leading HostDesign companies in the world.</p>
            <StyledButton btn="See Current Jobs" />
            <img src={image} />
        </div>
    )
};
export default Jobs ;